import React, { Component, useEffect, useState } from "react";
import joi from "joi";
import { Modal, Container, Col } from "react-bootstrap";
import { Button } from "react-bootstrap";
// import EquipmentType from './../EquipmentType/EquipmentType';
import swal from "sweetalert";
import validation from "../utill/validation";
import { Collapse, Row, Space } from "antd";
import axios from "axios";
import api from "../config.json";
import Table from "../Common/table";
import dateTime from "../utill/dateTime";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faEye,
  faPlus,
  faFileImport,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import Excelimport from "../utill/Excelimport";
import Loading from "../utill/LoadingComponent";
import { Select as AntdSelect } from "antd";
import { QRCodeSVG } from "qrcode.react";
import XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import _ from "lodash";
import Operation from "antd/lib/transfer/operation";

const ProcessedData = ({ RightName, getRightsForAccess, Heading }) => {
  const [sortColumn, setSortColumn] = useState({
    path: "PartID",
    order: "asc",
  });
  const history = useHistory();
  const [size, setSize] = useState("lg");
  const [opStatus, setopStatus] = useState("");
  const [Inputdata, setInputData] = useState({});
  const [componentList, setcomponentList] = useState([]);
  const [modelState, setmodelState] = useState(false);
  const [modelState1, setmodelState1] = useState(false);

  const [Update, setUpdate] = useState({});
  const [loader, setLoader] = useState(false);
  const [templateList, setTemplateList] = useState([]);
  const [VendorList, setVendorList] = useState([]);
  const [RMStorageList, setRMStorageList] = useState([]);

  const [selectedTemplate, setSelectedTemplate] = useState({ Columns: [] });

  const [rows, setRows] = useState([]);
  const [errors1, setErrors1] = useState({});
  const [errors, seterrors] = useState({});
  const [ImageList, setImageList] = useState([]);
  const [QRCodeVisible, setQRCodeVisible] = useState(false);
  const [Data, setData] = useState([]);
  const [PdfData, setPdfData] = useState([]);
  const [QRCodeArray, SetQRCodeArray] = useState([]);
  const [EnableAllPdf, SetEnableAllPdf] = useState(false);
  const [AdjustedQty, setAdjustedQty] = useState([]);
  const [MoldMaster, setMoldMaster] = useState([]);

  const [remarksInput, setRemarksInput] = useState({});

  const [Type, setType] = useState("");
  const [Quantity, setQuantity] = useState("");

  const [BatchCode, setBatchCode] = useState("");

  const [Remarks, setRemarks] = useState("");
  const [RawMaterialData, setRawMaterialData] = useState([]);

  const [ChekpointId, setChekpointId] = useState("");
  const [formData, setFormData] = useState({});
  const [Date, setDate] = useState([]);
  const [spareList, setspareList] = useState([]);
  const { Panel } = Collapse;
  function callback(key) {
    console.log(key);
  }
  console.log(RawMaterialData, "vhfvhdfvbhbvd");
  const handelOnPDfEnable = (e, input) => {
    let data = [...componentList];

    if (e.currentTarget.checked) {
      // Enable the PDF and add it to the list if not already present
      const exists = data.some((item) => item._id === input._id);

      if (!exists) {
        const updatedInput = { ...input, Enable: true }; // Avoid mutating input
        data.push(updatedInput);
      } else {
        data = data.map((item) =>
          item._id === input._id ? { ...item, Enable: true } : item
        );
      }

      SetEnableAllPdf(true); // Set "EnableAllPdf" to true
    }
    if (!e.currentTarget.checked) {
      data = data.map((item) => {
        console.log("jhveffj", item._id === input._id, item, input);
        return item._id === input._id ? { ...item, Enable: false } : item;
      });
    }
    setcomponentList(data);
    console.log(e.currentTarget.checked, "sdhbsdfusd", data);
    setPdfData(data);
  };
  const handelSelectAll = (e) => {
    const isChecked = e.currentTarget.checked;

    // Update the componentList with updated 'Enable' values
    const updatedList = componentList.map((one) => ({
      ...one,
      Enable: isChecked,
    }));

    // Update state
    setcomponentList(updatedList);
    setPdfData(updatedList);
    SetEnableAllPdf(isChecked);
  };

  const columns = [
    // {
    //   key: "select",
    //   label: <input type="checkbox" onChange={handelSelectAll} />,
    //   content: (obj) => (
    //     <input type="checkbox" checked={obj['Enable']} onChange={(e) => handelOnPDfEnable(e, obj)} />
    //   ),
    // },
    { path: "CompoundCode", label: "Compound Code" },

    { path: "ChemicalMixCheckpoint", label: "Chemical Mix Checkpoint" },
    { path: "OilsCheckpoint", label: "Oils Checkpoint" },
    { path: "Carbon", label: "Carbon" },
    { path: "Polymer", label: "Polymer" },
    { path: "Kneader_ID", label: "Kneader_ID" },
    { path: "KneadedAt", label: "Kneaded At" },
    {
      path: "GreenSheetStorageLocation",
      label: "Green Sheet Storage Location",
    },
    {
      path: "TotalGreenSheetsQtyProduced",
      label: "Total Green Sheets Qty Produced",
    },
    { path: "GreenSheetAvailable", label: "Green Sheet Available" },

    {
      path: "createdAt",
      label: "Created Date",
      content: (obj) => (
        <React.Fragment>
          <label>{dateTime.getStringOfDateTime(obj.createdAt)}</label>
          <br />
        </React.Fragment>
      ),
    },
    {
      path: "updatedAt",
      label: "Last Updated Date",
      content: (obj) => (
        <React.Fragment>
          <label>{dateTime.getStringOfDateTime(obj.updatedAt)}</label>
          <br />
        </React.Fragment>
      ),
    },
    {
      key: "update",
      content: (user) => (
        <button
          disabled={
            !getRightsForAccess("StaticDataRights", RightName, "update")
          }
          onClick={() => {
            // setInputData(user)
            console.log(user, "dshvgvbskbvksjb");
            setUpdate(user);
            setopStatus("view");
          }}
          className="btn btn-sm btn-primary"
        >
          <FontAwesomeIcon icon={faEye} />
        </button>
      ),
    },
    // {
    //   key: "update",
    //   content: (user) => (
    //     <button
    //       disabled={
    //         !getRightsForAccess("StaticDataRights", RightName, "update")
    //       }
    //       onClick={() => {
    //         // setInputData(user)
    //         console.log(user, "dshvgvbskbvksjb");
    //         setUpdate(user);
    //         setopStatus("update");
    //       }}
    //       className="btn btn-sm btn-primary"
    //     >
    //       <FontAwesomeIcon icon={faEdit} />
    //     </button>
    //   ),
    // },
    // { key: 'view', content: user => <button onClick={() => onView(user)} className="btn btn-sm btn-info"><FontAwesomeIcon icon={faEye} /></button> },
    // { key: 'delete', content: user => <button disabled={!getRightsForAccess('StaticDataRights', RightName, "update")} onClick={() => onDelete(user)} className="btn btn-sm btn-danger"><FontAwesomeIcon icon={faTrash} /></button> }
  ];

  useEffect(() => {
    if (opStatus == "view" || opStatus == "update") {
      setRows(Update.checkpoints);
      setQRCodeVisible(true);
      setInputData(Update);
      setmodelState(true);
    } else {
      setRows([]);
    }
  }, [opStatus]);

  console.log(Update, "wkhfwehkf");
  useEffect(() => {
   

    Heading("Process Data");
    RawMatreialMaster();
    getRMTypeMaster();
    getVendorMaster();
    getRMStorageMaster();
    getComponentCodeData();
  }, []);
  const getVendorMaster = () => {
    axios
      .get(api.api + "vendor")
      .then((result) => {
        const list = result.data.map((one) => ({
          Name: one.Vendor,
          value: one.Vendor,
        }));
        setVendorList(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getRMStorageMaster = () => {
    axios
      .get(api.api + "rmStorageWater")
      .then((result) => {
        const list = result.data.map((one) => ({
          Name: one.StorageLocation,
          value: one.StorageLocation,
        }));
        setRMStorageList(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getRMTypeMaster = () => {
    axios
      .get(api.api + "RMMaster")
      .then((result) => {
        const list = result.data.map((one) => ({
          Name: one.RM_Type,
          value: one.RM_Type,
        }));
        setTemplateList(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getComponentCodeData = () => {
    // axios
    //   .get(api.api + "RM_Type")
    //   .then((result) => {
    //     setcomponentList(result.data);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  };
  const RawMatreialMaster = () => {
    axios
      .get(api.api + "processData")
      .then((result) => {
        setRawMaterialData(result.data);
          
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //     const page = document.getElementsByClassName('a4-page')[i];
  //     const canvas = await html2canvas(page);
  //     const imgData = canvas.toDataURL('image/png');
  //     const imgProps = pdf.getImageProperties(imgData);
  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

  //     pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
  //     if (i < qrCodeGroups.length - 1) pdf.addPage();
  //   }
  //   pdf.save(`${Inputdata.RM_Type+'_' + Inputdata.InvoiceNo + '_'+Inputdata.NumOfStickers}.pdf`);
  // };
  // const A4Sheet = ( QRCodeVisible, Inputdata, rows = 3, cols = 3 ) => {
  //   // Split the QR codes into groups of 4
  //   const qrCodeGroups = [];
  //   const NumberOfStickerOnPage = 6;
  //   if (QRCodeVisible) {
  //     const totalStickers = Number(Inputdata.NumOfStickers);
  //     for (let i = 0; i < totalStickers; i += NumberOfStickerOnPage) {
  //       qrCodeGroups.push([...Array(Math.min(NumberOfStickerOnPage, totalStickers - i))].map((_, j) => i + j));
  //     }
  //   }

  //   // Function to download the PDF
  //   const downloadPDF = (qrCodeGroups, Inputdata) => {
  //     const doc = new jsPDF();
  //     const QrCode = `CC:${Inputdata.RM_Type};BN:${Inputdata.InvoiceNo};TC:${Inputdata.TestReportNo};MD:${Inputdata.InvoiceDate};ED:${Inputdata.ExpiryDate};QT:${Inputdata.Qty}`;

  //     qrCodeGroups.forEach((group, pageIndex) => {
  //       if (pageIndex > 0) {
  //         doc.addPage(); // Add a new page for every group after the first
  //       }

  //       group.forEach((index, groupIndex) => {
  //         const x = 10 + (groupIndex % 2) * 100; // Position horizontally
  //         const y = 10 + Math.floor(groupIndex / 2) * 60; // Position vertically
  //         // Adding QR code
  //         doc.addImage(QrCode, 'PNG', x, y, 50, 50);

  //         // Adding text below the QR code
  //         const textY = y + 55; // Space below QR code for text
  //         doc.setFontSize(12);
  //         doc.text(Inputdata.RM_Type, x, textY);
  //         doc.text(Inputdata.InvoiceNo, x, textY + 10);
  //         doc.text(`${index + 1} / ${Inputdata.NumOfStickers}`, x, textY + 20);
  //       });
  //     });

  //     doc.save('qr-codes.pdf'); // Trigger PDF download
  //   };

  //   const QrCode = `CC:${Inputdata.RM_Type};BN:${Inputdata.InvoiceNo};TC:${Inputdata.TestReportNo};MD${Inputdata.InvoiceDate};ED:${Inputdata.ExpiryDate};QT:${Inputdata.Qty}`;

  //   return (
  //     <div>
  //       <Button type="primary" onClick={() => { downloadPDF(qrCodeGroups, Inputdata); }} style={{ marginBottom: '16px' }}>
  //         Download as PDF
  //       </Button>
  //       <div className="a4-sheet-scrollable">
  //         {qrCodeGroups.map((group, pageIndex) => (
  //           <div className="a4-page" key={pageIndex} style={{ pageBreakAfter: 'always' }}>
  //             {group.map(index => (
  //               <div className="d-flex justify-content-center" key={index}>
  //                 <div className='p-5'>
  //                   <QRCodeSVG className='d-flex justify-content-center my-3' value={QrCode} size={100} />
  //                   <h6 className="bolder text-center">{Inputdata.RM_Type}</h6>
  //                   <h6 className="bolder text-center">{Inputdata.InvoiceNo}</h6>
  //                   <h6 className="bolder text-center">{index + 1 + ' / ' + Inputdata.NumOfStickers}</h6>
  //                 </div>
  //               </div>
  //             ))}
  //           </div>
  //         ))}
  //       </div>
  //     </div>
  //   );
  // };
  const downloadPDF = async (qrCodeGroups, Inputdata) => {
    console.log(qrCodeGroups, Inputdata, "currect dowload function dta");
    const pdf = new jsPDF("p", "mm", "b5");
    for (let i = 0; i < qrCodeGroups.length; i++) {
      const page = document.getElementsByClassName("a4-page")[i];
      const canvas = await html2canvas(page);
      const imgData = canvas.toDataURL("image/png");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      if (i < qrCodeGroups.length - 1) pdf.addPage();
    }
    pdf.save(
      `Processdata.pdf`
    );

    if (opStatus !== "view") {
      handleCloseModel();
    }
  };

  const A4Sheet = (QRCodeVisible, Inputdata) => {
    // Split the QR codes into groups of 4
    const qrCodeGroups = [];
    const stickersPerPage = 16; // 4x4 grid on each page
    if (QRCodeVisible) {
      const totalStickers = Number(Inputdata.NumOfStickers);
      // const stickersPerPage = 9; // 3x3 grid on each page
      for (let i = 0; i < totalStickers; i += stickersPerPage) {
        qrCodeGroups.push(
          [...Array(Math.min(stickersPerPage, totalStickers - i))].map(
            (_, j) => i + j
          )
        );
      }
    }

    // Prepare the QR Code value to display in each QRCodeSVG
    const QrCode = `CC : ${Inputdata.RM_Type};BN : ${
      Inputdata.InvoiceNo
    };TC : ${Inputdata.TestReportNo};MD : ${moment(
      Inputdata.InvoiceDate
    ).format("DD-MM-YY")};ED : ${moment(Inputdata.ExpiryDate).format(
      "DD-MM-YY"
    )};QT : ${Inputdata.Qty}`;

    return (
      <div>
        {opStatus === "view" && (
          <Button
            type="primary"
            onClick={() => downloadPDF(qrCodeGroups, Inputdata)}
            style={{ marginBottom: "16px" }}
          >
            Download as PDF
          </Button>
        )}

        <div className="a4-sheet-scrollable">
          {qrCodeGroups.map((group, pageIndex) => (
            <div
              className="a4-page"
              key={pageIndex}
              style={{ pageBreakAfter: "always" }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: `repeat(${Math.sqrt(
                    stickersPerPage
                  )}, 1fr)`, // 3 columns in each row
                  gridTemplateRows: `repeat(${Math.sqrt(
                    stickersPerPage
                  )}, auto)`, // 3 rows per page (auto height)
                  gap: "35px", // Optional: Adjust the gap between items as needed
                  justifyItems: "center",
                  alignItems: "center",
                }}
              >
                {group.map((index) => (
                  <div
                    className="d-flex flex-column justify-content-center align-items-center"
                    key={index}
                    style={{ textAlign: "center" }}
                  >
                    <QRCodeSVG level="M" value={QrCode} size={90} />{" "}
                    {/* Adjust the size of the QR code */}
                    <p
                      style={{ fontSize: "10px", color: "black" }}
                      className="bolder"
                    >
                      {Inputdata.RM_Type}
                    </p>
                    <p
                      style={{ fontSize: "10px", color: "black" }}
                      className="bolder"
                    >
                      {Inputdata.InvoiceNo}
                    </p>
                    <p
                      style={{ fontSize: "10px", color: "black" }}
                      className="bolder"
                    >{`${index + 1} / ${Inputdata.NumOfStickers}`}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };
  const handleSort = (sortColumn) => {
    if (componentList.length > 0) {
      const sorted = _.orderBy(
        componentList,
        [sortColumn.path],
        [sortColumn.order]
      );
      setSortColumn(sortColumn);

      setcomponentList(sorted);
    }
  };
  const handleCloseModel = () => {
    setopStatus("");
    setmodelState(false);
  };
  const handleHideModel = () => {
    setopStatus("");
    setmodelState(false);
  };
  const handleCloseModel1 = () => {
    setopStatus("");
    setmodelState1(false);
  };
  const handleHideModel1 = () => {
    setopStatus("");
    setmodelState1(false);
  };
  const schema = {
    InvoiceNo: joi.string().required(),
    RM_Type: joi.string().required(),
    TestReportNo: joi.string().required(),
    InvoiceDate: joi.string().required(),
    ExpiryDate: joi.string().required(),
    Qty: joi.number().required(),
    NumOfStickers: joi.number().required(),
    _id: joi.string(),
  };

  const handleOnChange = (e) => {
    const { name, value } = e.currentTarget;

    setInputData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const downloadExcel = () => {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Prepare data with headers only
    const headers = getColumnsWithoutUserInput(selectedTemplate.Columns).map(
      (column) => column.DbFieldName
    );
    headers.unshift("StandardType");
    const worksheetData = [headers];

    // Create a worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Generate and download the Excel file
    XLSX.writeFile(workbook, `${selectedTemplate.Name}_template.xlsx`);
  };

  const getColumnsWithoutUserInput = (allColumns = []) => {
    const columns = [...allColumns];
    return columns.filter((x) => !x.DataType.startsWith("UserInput"));
  };

  const handleFileUpload = (e) => {
    const fileInputElement = document.createElement("input");
    fileInputElement.type = "file";
    fileInputElement.accept = ".xlsx, .xls";
    fileInputElement.multiple = false;

    // Handle the file upload when the user selects a file
    fileInputElement.addEventListener("change", (event) => {
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => {
        const binaryStr = e.target.result;
        const workbook = XLSX.read(binaryStr, { type: "binary" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        const headers = jsonData[0];
        const rows = jsonData.slice(1);
        const formattedData = rows.map((row) => {
          let obj = {};
          row.forEach((cell, index) => {
            obj[headers[index]] = cell;
          });
          return obj;
        });
        setRows(formattedData);
        // Clean up: remove the file input element from the DOM
        fileInputElement.remove();
      };

      // Read the file as a binary string
      reader.readAsBinaryString(file);
    });

    // Programmatically trigger the file input click
    fileInputElement.click();
  };

  const onDelete = (data) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axios
          .delete(api.api + "compoundCode/" + data._id, { data: data })
          .then((result) => {
            getComponentCodeData();
            toast.success(`Deleted  Successfully`, {
              position: "bottom-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: {
                background: "green", // Set your desired background color
                color: "white", // Set your desired text color
              },
            });
          })
          .catch((err) => {
            if (err.response && err.response.data) {
              swal(`${err.response.data.message}`);
            } else {
              swal(`${err}`);
            }
            // toast.success(`${err}`, {
            //   position: 'bottom-right',
            //   autoClose: 2000,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   style: {
            //     background: 'red', // Set your desired background color
            //     color: 'white',     // Set your desired text color
            //   },
            // });
          });
      } else {
        // this.setState({ querySuccess: false });
        // swal("Your imaginary file is safe!");
      }
    });
  };

  const validateCheckCheckPoints = (rows = []) => {
    let errorObj = { IsError: false, message: [] };
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].StandardType == "Dimension") {
        const dimensionField = selectedTemplate.Columns.find(
          (x) => x.DataType == "StandardDimension"
        );
        if (dimensionField && !rows[i][dimensionField.DbFieldName]) {
          errorObj.IsError = true;
          errorObj.message.push(
            `Row Number ${i + 1} ${
              dimensionField.FieldName
            } is mandatory for Dimension Type check point.`
          );
          break;
        }
      }
    }
    return errorObj;
  };

  const handelSaveData = (data, AdjustedQty) => {
    console.log(data, "cvosjnvjnv", AdjustedQty);
    const checksheet = { ...AdjustedQty[0] };
    // delete checksheet.__v
    // delete checksheet.createdAt
    // delete checksheet.updatedAt
    // const errors = validation.validate(checksheet, schema);
    // if (errors) {
    //   seterrors(errors);
    //   return;
    // }
    checksheet["UniqueID"] = data.UniqueID;
    setLoader(true);
    if (opStatus == "update") {
      axios
        .post(api.api + "adjustInventory", checksheet)
        .then((result) => {
          swal("Data Update Successfully");
          getComponentCodeData();
          // setQRCodeVisible(true);

          handleCloseModel();
          setLoader(false);
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            swal(err.response.data.message, { dangerMode: true });
          }
          console.log(err);
          setLoader(false);
        });
    } else {
      axios
        .post(api.api + "compoundCode", checksheet)
        .then((result) => {
          console.log(result, "cdisivbi");
          swal("Data Saved Successfully");
          // Split the QR codes into groups of 4
          setQRCodeVisible(true);
          const qrCodeGroups = [];
          const stickersPerPage = 16; // 4x4 grid on each page
          // if (QRCodeVisible) {
          const totalStickers = Number(Inputdata.NumOfStickers);
          // const stickersPerPage = 9; // 3x3 grid on each page
          for (let i = 0; i < totalStickers; i += stickersPerPage) {
            qrCodeGroups.push(
              [...Array(Math.min(stickersPerPage, totalStickers - i))].map(
                (_, j) => i + j
              )
            );
          }
          // }
          if (qrCodeGroups.length > 0) {
            downloadPDF(qrCodeGroups, Inputdata);
          }
          // if(Result){
          //   handleCloseModel()
          // }
          getComponentCodeData();

          setLoader(false);
          seterrors({});
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            swal(err.response.data.message, { dangerMode: true });
          }
          console.log(err);
          setLoader(false);
        });
    }
  };
  const downloadPDFforAll = (data) => {
    const pdf = [];

    data.map(
      (one) =>
        one.Enable &&
        [...Array(Math.min(one.NumOfStickers))].forEach((_, j) => {
          pdf.push({
            QrCode: `CC : ${one.CompoundCode};BN : ${one.InvoiceNo};TC : ${
              one.TestReportNo
            };MD : ${moment(one.InvoiceDate).format("DD-MM-YY")};ED : ${moment(
              one.ExpiryDate
            ).format("DD-MM-YY")};QT : ${one.Qty}`,
            index: j,
            InvoiceNo: one.InvoiceNo,
            CompoundCode: one.CompoundCode,
            TestReportNo: one.TestReportNo,

            NumOfStickers: one.NumOfStickers,
          });
        })
    );
    const qrCodeGroups = [];
    const stickersPerPage = 20; // 4x4 grid on each page
    // if (QRCodeVisible) {
    const totalStickers = Number(pdf.length);
    // const stickersPerPage = 9; // 3x3 grid on each page
    for (let i = 0; i < pdf.length; i += stickersPerPage) {
      qrCodeGroups.push(pdf.slice(i, i + stickersPerPage));
    }

    // }
    console.log("downloadPDF", data, pdf, qrCodeGroups);
    setmodelState1(true);
    SetQRCodeArray(qrCodeGroups);
  };

  const handelONaddSpare = (Date, Type, Quantity, Remarks) => {
    if (Date && Type && Quantity) {
      setAdjustedQty((prev) => [
        ...prev,
        { Date: Date, Type: Type, Qty: Quantity, Remarks: Remarks },
      ]);
    } else {
      swal("Please Fill Required Fields");
    }
    setDate("");
    setQuantity("");

    setType("");
    setRemarks("");
  };
  return (
    <>
      {/* <div className='text-center'>
       
        <p>Checksheet Master</p>
      </div> */}
      {loader ? <Loading /> : <></>}

      <Modal
        backdrop={"static"}
        className=""
        size={size}
        show={modelState}
        onHide={handleHideModel}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center">
           Process Data
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="collapse" data-parent="#parent" id={`Inputdata${id}`}> */}
          <Row>
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex ">
                <div className="w-25" htmlFor="operationRejectionCost">
                 Component Code
                </div>
                <div className="w-75">
                 
                  <input
                    required
                    // onChange={handleOnChange}
                    style={{ width: "100%" }}
                    placeholder="Test Report Number"
                    disabled={true}
                    className="form-control form-control-sm"
                    type="text"
                    // min="0"
                    name="CompoundCode"
                    value={Inputdata.CompoundCode}
                  />
                </div>

                {errors.CompoundCode && (
                  <div className="alert small alert-danger">
                    {errors["CompoundCode"]}
                  </div>
                )}
              </div>
            </Col>
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                Chemical Mix Checkpoint
                </div>
                <div className="w-75">
                 
                  <input
                    required
                    // onChange={handleOnChange}
                    style={{ width: "100%" }}
                    placeholder="No Data"
                    disabled={true}
                    className="form-control form-control-sm"
                    type="text"
                    // min="0"
                    name="ChemicalMixCheckpoint"
                    value={Inputdata.ChemicalMixCheckpoint}
                  />
                </div>

                {errors.ChemicalMixCheckpoint && (
                  <div className="alert small alert-danger">
                    {errors["ChemicalMixCheckpoint"]}
                  </div>
                )}
              </div>
            </Col>
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                Oils Checkpoint
                </div>
                <div className="w-75">
                 
                  <input
                    required
                    // onChange={handleOnChange}
                    style={{ width: "100%" }}
                    placeholder="Oils Checkpoint"
                    disabled={true}
                    className="form-control form-control-sm"
                    type="text"
                    // min="0"
                    name="OilsCheckpoint"
                    value={Inputdata.OilsCheckpoint}
                  />
                </div>

                {errors.OilsCheckpoint && (
                  <div className="alert small alert-danger">
                    {errors["OilsCheckpoint"]}
                  </div>
                )}
              </div>
            </Col>
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                Carbon
                </div>
                <div className="w-75">
                 
                  <input
                    required
                    // onChange={handleOnChange}
                    style={{ width: "100%" }}
                    placeholder="No Data"
                    disabled={true}
                    className="form-control form-control-sm"
                    type="text"
                    // min="0"
                    name="Carbon"
                    value={Inputdata.Carbon}
                  />
                </div>

                {errors.Carbon && (
                  <div className="alert small alert-danger">
                    {errors["Carbon"]}
                  </div>
                )}
              </div>
            </Col><Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                Polymer
                </div>
                <div className="w-75">
                 
                  <input
                    required
                    // onChange={handleOnChange}
                    style={{ width: "100%" }}
                    placeholder="No Data"
                    disabled={true}
                    className="form-control form-control-sm"
                    type="text"
                    // min="0"
                    name="Polymer"
                    value={Inputdata.Polymer}
                  />
                </div>

                {errors.Polymer && (
                  <div className="alert small alert-danger">
                    {errors["Polymer"]}
                  </div>
                )}
              </div>
            </Col><Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                Kneader ID
                </div>
                <div className="w-75">
                 
                  <input
                    required
                    // onChange={handleOnChange}
                    style={{ width: "100%" }}
                    placeholder="No Data"
                    disabled={true}
                    className="form-control form-control-sm"
                    type="text"
                    // min="0"
                    name="Kneader_ID"
                    value={Inputdata.Kneader_ID}
                  />
                </div>

                {errors.Kneader_ID && (
                  <div className="alert small alert-danger">
                    {errors["Kneader_ID"]}
                  </div>
                )}
              </div>
            </Col><Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                Kneaded At
                </div>
                <div className="w-75">
                 
                  <input
                    required
                    // onChange={handleOnChange}
                    style={{ width: "100%" }}
                    placeholder="No Data"
                    disabled={true}
                    className="form-control form-control-sm"
                    type="text"
                    // min="0"
                    name="Kneaded At"
                    value={Inputdata.KneaderAt}
                  />
                </div>

                {errors.KneaderAt && (
                  <div className="alert small alert-danger">
                    {errors["KneaderAt"]}
                  </div>
                )}
              </div>
            </Col><Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                Green Sheet Storage Location
                </div>
                <div className="w-75">
                 
                  <input
                    required
                    // onChange={handleOnChange}
                    style={{ width: "100%" }}
                    placeholder="No Data"
                    disabled={true}
                    className="form-control form-control-sm"
                    type="text"
                    // min="0"
                    name="Green Sheet Storage Location"
                    value={Inputdata.GreenSheetStorageLocation}
                  />
                </div>

                {errors.GreenSheetStorageLocation && (
                  <div className="alert small alert-danger">
                    {errors["GreenSheetStorageLocation"]}
                  </div>
                )}
              </div>
            </Col>
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                Total Green Sheets Qty Produced
                </div>
                <div className="w-75">
                 
                  <input
                    required
                    // onChange={handleOnChange}
                    style={{ width: "100%" }}
                    placeholder="No Data"
                    disabled={true}
                    className="form-control form-control-sm"
                    type="text"
                    // min="0"
                    name="TotalGreenSheetsQtyProduced"
                    value={Inputdata.TotalGreenSheetsQtyProduced}
                  />
                </div>

                {errors.TotalGreenSheetsQtyProduced && (
                  <div className="alert small alert-danger">
                    {errors["TotalGreenSheetsQtyProduced"]}
                  </div>
                )}
              </div>
            </Col>
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                Green Sheet Available
                </div>
                <div className="w-75">
                 
                  <input
                    required
                    // onChange={handleOnChange}
                    style={{ width: "100%" }}
                    placeholder="No Data"
                    disabled={true}
                    className="form-control form-control-sm"
                    type="text"
                    // min="0"
                    name="Green Sheet Available"
                    value={Inputdata.GreenSheetAvailable}
                  />
                </div>

                {errors.GreenSheetAvailable && (
                  <div className="alert small alert-danger">
                    {errors["GreenSheetAvailable"]}
                  </div>
                )}
              </div>
            </Col>
            <Col sm={12}>
              <Collapse defaultActiveKey={["1","2"]} onChange={callback}>
                <Panel header="Activation" key="1">
                  <Col sm={12}>
                    {/* <div   htmlFor="operationRejectionCost mb-2"></div  > */}

                    <div className="">
                      <table className="table table-striped small table-bordered table-sm table-hover common my-1">
                        <thead className="small">
                          <tr className="table-primary text-center common-anchor">
                            <td>ChemicalMixCheckpoint</td>
                            <td>ActivatedAt</td>
                            <td>MixingMill </td>
                            <td>QtyProduced </td>
                            <td>NumberOFSheets </td>
                            <td>DateofMfg </td>
                            <td>ExpiryDate </td>
              
                          </tr>
                        </thead>
                        <tbody>
                          {Inputdata.Activation &&
                            Inputdata.Activation.length > 0 &&
                            Inputdata.Activation.map((item) => (
                              <tr className=" text-center">
                                <td>{item.ChemicalMixCheckpoint} </td>
                                <td>{item.ActivatedAt}</td>
                                <td>{item.MixingMill}</td>
                                <td>{item.QtyProduced}</td>
                                <td>{item.NumberOfSheets}</td>
                                <td>{item.DateOfMfg}</td>
                                <td>{item.UsedBy}</td>


                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>

                    {/* {errors.ExpiryDate && (
                  <div className="alert small alert-danger">
                    {errors["ExpiryDate"]}
                  </div>
                )} */}
                  </Col>
                </Panel>
                <Panel header="Adjusted Qty" key="2">
                  <Col sm={12}>
                    {/* <div   htmlFor="operationRejectionCost mb-2">Adjusted Qty</div  > */}
                    <div className="">
                       
                    
                      <div className="">
                        <table className="table table-striped small table-bordered table-sm table-hover common my-1">
                          <thead className="small">
                            <tr className="table-primary text-center common-anchor">
                              <td>Date</td>
                              <td>Quantity</td>
                              <td>Type</td>
                              <td>Remarks</td>
                            </tr>
                          </thead>
                          <tbody>
                            {Inputdata.AdjustedGreenSheetQty &&
                              Inputdata.AdjustedGreenSheetQty.length > 0 &&
                              Inputdata.AdjustedGreenSheetQty.map((item) => (
                                <tr className="text-center">
                                  <td
                                    style={{
                                      backgroundColor: `${
                                        item.Type == "Reduce"
                                          ? "#ffd6d2"
                                          : "#c9ffef"
                                      }`,
                                    }}
                                  >
                                    {moment(item.Date).format("DD-MM-YYYY")}
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor: `${
                                        item.Type == "Reduce"
                                          ? "#ffd6d2"
                                          : "#c9ffef"
                                      }`,
                                    }}
                                  >
                                    {item.Qty}
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor: `${
                                        item.Type == "Reduce"
                                          ? "#ffd6d2"
                                          : "#c9ffef"
                                      }`,
                                    }}
                                  >
                                    {item.Type}
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor: `${
                                        item.Type == "Reduce"
                                          ? "#ffd6d2"
                                          : "#c9ffef"
                                      }`,
                                    }}
                                  >
                                    {item.Remarks}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    {/* {errors.ExpiryDate && (
                  <div className="alert small alert-danger">
                    {errors["ExpiryDate"]}
                  </div>
                )} */}
                  </Col>
                </Panel>
              </Collapse>
            </Col>
        
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseModel()}>
            Close
          </Button>
          {opStatus === "view" ? (
            ""
          ) : (
            <Button
              variant="primary"
              onClick={() => {
                const error = validateCheckCheckPoints(rows);
                if (error.IsError) {
                  swal("ERROR", error.message.join(", "), { dangerMode: true });
                } else {
                  handelSaveData(Inputdata, AdjustedQty);
                }
              }}
            >
              Submit
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <Modal
        backdrop={"static"}
        className=""
        size={size}
        show={modelState1}
        onHide={handleHideModel1}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center">Inventory Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="collapse" data-parent="#parent" id={`Inputdata${id}`}> */}

          {console.log(Inputdata.NumOfStickers, "snsdonsdn")}
          <div className="a4-sheet">
            {
              QRCodeArray && QRCodeArray.length > 0 && (
                <div>
                  <Button
                    type="primary"
                    onClick={() => downloadPDF(QRCodeArray, Inputdata)}
                    style={{ marginBottom: "16px" }}
                  >
                    Download as PDF
                  </Button>

                  {QRCodeArray.map((group, index) => (
                    <div className="a4-sheet-scrollable">
                      <div
                        className="a4-page"
                        // key={pageIndex}
                        style={{ pageBreakAfter: "always" }}
                      >
                        <div
                                                   style={{
                                                     display: "grid",
                                                     gridTemplateColumns: `repeat(${Math.sqrt(
                                                       16
                                                     )}, 1fr)`, // 3 columns in each row
                                                     gridTemplateRows: `repeat(${Math.sqrt(
                                                       16
                                                     )}, auto)`, // 3 rows per page (auto height)
                                                     gap: "57px", // Optional: Adjust the gap between items as needed
                                                     justifyItems: "center",
                                                     alignItems: "center",
                                                   }}
                                                 >
                                                   {group.map((one, index) => (
                                                     <div
                                                       className="d-flex flex-column justify-content-center align-items-center "
                                                       key={index}
                                                       style={{ textAlign: "center",marginBottom:'10px'}}
                                                     >
                                                       <QRCodeSVG
                                                         value={one.QrCode}
                                                         level={'M'}
                                                         size={80}
                                                         style={{marginBottom:'3px'}}
                                                       />{" "}
                              {/* Adjust the size of the QR code */}
                              <p
                                style={{
                                  fontSize: "9px",
                                  color: "black",
                                  letterSpacing: "0.5px",
                                  lineHeight: "1.2",
                                }}
                              >
                                {one.RM_Type}
                                <br />
                                {one.InvoiceNo}
                                <br />

                                {`${1 + one.index} / ${one.NumOfStickers}`}
                              </p>
                             
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )
              // [...Array(Number(Inputdata.NumOfStickers))].map((_, index) => (
              //   <Space className="qr-space" key={index} direction="vertical" align="center">
              //     <QRCodeSVG value={JSON.stringify(Inputdata)} size={100} />
              //     <p>{index + 1 + ' / ' + Inputdata.NumOfStickers}</p>
              //   </Space>
              // ))
            }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseModel1()}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* {
        <button
          disabled={!getRightsForAccess("StaticDataRights", RightName, "write")}
          className="btn-sm btn-primary float-right"
          onClick={() => {
            setQRCodeVisible(false);
            setmodelState(true);
            setInputData({});
            setUpdate({});
            setSelectedTemplate({});
          }}
        >
          Create Inventory
        </button>
      } */}
      {/* <button type="button" className="btn-sm btn-primary  mx-2" 
    // onClick={()=>handleUploadGuagesDoc()}
    >
      <FontAwesomeIcon icon={faFileImport} /> Import Excel</button> */}
      {/* {getRightsForAccess('StaticDataRights', RightName, "write") && <Excelimport />} */}
      {PdfData && PdfData.length > 0 && EnableAllPdf && (
        <button
          type="button"
          className="btn-sm btn-primary"
          onClick={() => downloadPDFforAll(PdfData)}
        >
          Download PDFs
        </button>
      )}
      {RawMaterialData.length < 0 ? (
        "Data Not Available"
      ) : (
        <Table
          columns={columns}
          onSort={handleSort}
          sortColumn={sortColumn}
          data={RawMaterialData}
        />
      )}
    </>
  );
};

export default ProcessedData;
